import { useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroBanner from './components/HeroBanner';
import ServicesSection from './components/ServicesSection';
import PortfolioSection from './components/PortfolioSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function HomePage() {
  useEffect(() => {
    const siteUrl = (import.meta.env.VITE_SITE_URL as string) || 'https://example.com';

    // Canonical link
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = siteUrl;
    canonical.id = 'home-canonical';
    document.head.appendChild(canonical);

    // og:url
    const ogUrl = document.createElement('meta');
    ogUrl.setAttribute('property', 'og:url');
    ogUrl.setAttribute('content', siteUrl);
    ogUrl.id = 'home-og-url';
    document.head.appendChild(ogUrl);

    // JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'home-jsonld';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'LocalBusiness',
          '@id': `${siteUrl}/#business`,
          name: '라인 인테리어',
          description:
            '서울 페인트·도장·방수 전문 업체. 15년 이상의 경험으로 아파트·상업 공간 내외벽 도장, 옥상·욕실 방수를 책임 시공합니다.',
          url: siteUrl,
          telephone: '010-5691-7704',
          email: 'djrwp93@naver.com',
          image: `https://public.readdy.ai/ai/img_res/27c1b15bd76e21cebd4fbf2d2eec22e5.jpg`,
          address: {
            '@type': 'PostalAddress',
            addressLocality: '서울',
            addressCountry: 'KR',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: '37.5665',
            longitude: '126.9780',
          },
          areaServed: {
            '@type': 'City',
            name: '서울',
          },
          openingHoursSpecification: [
            {
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
              opens: '09:00',
              closes: '18:00',
            },
          ],
          hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: '시공 서비스',
            itemListElement: [
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '페인트 시공' } },
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '도장 서비스' } },
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '방수 공사' } },
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '특수 도장' } },
            ],
          },
          priceRange: '₩₩',
          currenciesAccepted: 'KRW',
          paymentAccepted: '현금, 계좌이체, 카드',
        },
        {
          '@type': 'WebSite',
          '@id': `${siteUrl}/#website`,
          url: siteUrl,
          name: '라인 인테리어',
          description:
            '서울 페인트·도장·방수 전문 업체 라인 인테리어 공식 홈페이지',
          publisher: { '@id': `${siteUrl}/#business` },
          inLanguage: 'ko-KR',
        },
        {
          '@type': 'WebPage',
          '@id': `${siteUrl}/#webpage`,
          url: siteUrl,
          name: '서울 페인트·도장·방수 전문 업체 | 라인 인테리어',
          description:
            '라인 인테리어는 서울 페인트 시공, 도장, 방수 공사 전문 업체입니다. 15년 경력의 기술자가 무료 견적을 제공합니다.',
          isPartOf: { '@id': `${siteUrl}/#website` },
          about: { '@id': `${siteUrl}/#business` },
          inLanguage: 'ko-KR',
          dateModified: '2026-03-26',
        },
      ],
    });
    document.head.appendChild(script);

    return () => {
      document.getElementById('home-canonical')?.remove();
      document.getElementById('home-og-url')?.remove();
      document.getElementById('home-jsonld')?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <main>
        <HeroBanner />
        <ServicesSection />
        <PortfolioSection />
        <ContactSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}
